import request from '@/utils/zsm-requets'
import BASE_URL from "@/utils/BASE_URL.js"
// 营销模块
export const study = BASE_URL.ZSM_BASE_API_COMMERCE + '/commerce/api/study/'

/**
 * 记录学习时间
 * @params beforeTime	开始时间	
 * @params afterTime	结束时间
 * @params goodDetailId	章节编号
 * @params orderId	订单数据
 * @params giveFlag	是否是赠品订单
 * @params sourceDict	观看来源
 */
export function recordStudy(params) {
	return request({
		url: study + 'record',
		method: 'post',
		params
	}, {
		"Content-Type": "application/x-www-form-urlencoded"
	})
}

/**
 * 根据订单号查询用户学习时长
 * @params orderId	订单数据
 */
export function getWatchSecsByOrderId(orderId) {
	return request({
		url: study + 'getWatchSecsByOrderId',
		method: 'get',
		params: {
			orderId
		}
	}, {
		"Content-Type": "application/x-www-form-urlencoded"
	})
}